import axios from 'axios';

const RESOURCE_NAME = '/api/pdf';
const STREAM_CONFIG = {
    responseType: 'arraybuffer'
};

const DOWN_CONFIG = {
    responseType: 'blob'
};

export default {

    create(data) {
        return axios.post(RESOURCE_NAME, data, STREAM_CONFIG);
    },

    
};


// WEBPACK FOOTER //
// ./src/api-services/pdf.service.js